var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29244 15.7275C9.29244 13.6163 7.98744 11.85 7.28619 10.5413C6.89455 9.81136 6.6897 8.99585 6.68994 8.16752C6.68994 5.39252 9.22494 3.14252 11.9999 3.14252",
    stroke: "#1F3549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7075 15.7275C14.7075 13.6163 16.0125 11.85 16.7137 10.5413C17.1054 9.81136 17.3102 8.99585 17.31 8.16752C17.31 5.39252 14.775 3.14252 12 3.14252",
    stroke: "#1F3549"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1011 15.6113H9.10111C8.6227 15.6113 8.23486 15.9991 8.23486 16.4775C8.23486 16.9559 8.6227 17.3438 9.10111 17.3438H15.1011C15.5795 17.3438 15.9674 16.9559 15.9674 16.4775C15.9674 15.9991 15.5795 15.6113 15.1011 15.6113Z",
    stroke: "#1F3549"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 17.3438H9.57377C9.09535 17.3438 8.70752 17.7316 8.70752 18.21C8.70752 18.6884 9.09535 19.0762 9.57377 19.0762H14.625C15.1034 19.0762 15.4913 18.6884 15.4913 18.21C15.4913 17.7316 15.1034 17.3438 14.625 17.3438Z",
    stroke: "#1F3549"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4177 19.0762V19.425C13.4374 19.6091 13.4181 19.7954 13.3611 19.9716C13.3042 20.1478 13.2107 20.3101 13.087 20.4478C12.9632 20.5855 12.8118 20.6957 12.6426 20.7711C12.4735 20.8465 12.2904 20.8855 12.1052 20.8855C11.92 20.8855 11.7368 20.8465 11.5677 20.7711C11.3985 20.6957 11.2471 20.5855 11.1234 20.4478C10.9996 20.3101 10.9061 20.1478 10.8492 19.9716C10.7922 19.7954 10.7729 19.6091 10.7927 19.425V19.0762",
    stroke: "#1F3549"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57617 7.92752C8.61884 7.11529 8.98196 6.35316 9.58585 5.80832C10.1897 5.26348 10.9851 4.98043 11.7974 5.02127",
    stroke: "#1F3549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.8fdf6374cf565c49278906fb21ae9603.svg";
export { ForwardRef as ReactComponent };